<template>
  <div class="">
    <div v-if="text.length < maxChars">
      <p v-if="readMode == 'less'">{{ text }}</p>
    </div>
    <div v-else>
      <p v-if="readMode == 'less'">
        {{ lessText }}...
        <span class="more-btn text-dark ml-2" @click="changeReadMode('more')">{{
          moreString
        }}</span>
      </p>
      <p v-if="readMode == 'more'">
        {{ text }}
        <span class="more-btn text-dark ml-2" @click="changeReadMode('less')">{{
          lessString
        }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    maxChars: {
      type: Number,
      default: 100,
    },
    moreString: {
      type: String,
      default: "read more",
    },
    lessString: {
      type: String,
      default: "read less",
    },
  },
  computed: {
    lessText() {
      return this.text.substring(0, this.maxChars);
    },
  },

  data() {
    return {
      readMode: "less",
    };
  },
  methods: {
    changeReadMode(mode) {
      this.readMode = mode;
    },
  },
};
</script>
<style>
.more-btn:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
